import { ArrowLeft } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgLeftArrow2 = mkIcon(ArrowLeft);